export default "__VITE_ASSET__DsAJ5$SP__"